var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{attrs:{"data":_vm.activeId}}),_c('TopBar'),_c('InputField'),_c('TypeaheadList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }